<template>
  <div class="error-icon-overlay">
    <i class="cls cls-alert-circle has-text-danger is-size-3 delayed-show-lr"></i>
  </div>
</template>

<script>
export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'FormErrorRightIcon'
};
</script>
